(function() {
  'use strict';

  const POPUP_IMAGE_NAMESPACE = 'popup-image-component';

  class PopupImageComponent extends HTMLElement {
    constructor() {
      super();
      
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.closeButtons = this.querySelectorAll('[data-popup-image-close]');
      this.overlay = this.dialog;
      this.isAnimating = false;
      this.originalBodyOverflow = '';
      
      this.delay = this.dialog.getAttribute('data-popup-delay') || 'always';
      this.storageKey = this.dialog.getAttribute('data-cookie-name') || 'popup-image-closed';
      this.storageValue = this.dialog.getAttribute('data-cookie-value') || 'user_has_closed';
      this.targetReferrer = this.dialog.getAttribute('data-target-referrer');
      
      this.init();
    }

    init() {
      if (!this.checkTargetReferrer()) {
        return;
      }

      if (this.hasBeenClosed()) {
        return;
      }

      this.bindListeners();

      this.showPopupWithDelay();
    }

    checkTargetReferrer() {
      if (!this.targetReferrer) return true;
    
      if (window.location.href.indexOf(this.targetReferrer) === -1) {
        if (!window.Shopify || !window.Shopify.designMode) {
          this.remove();
          return false;
        }
      }
      
      return true;
    }

    hasBeenClosed() {
      try {
        const value = sessionStorage.getItem(this.storageKey);
        return value === this.storageValue;
      } catch (e) {
        console.warn('SessionStorage not available:', e);
        return false;
      }
    }

    markAsClosed() {
      try {
        sessionStorage.setItem(this.storageKey, this.storageValue);
      } catch (e) {
        console.warn('SessionStorage not available:', e);
      }
    }

    bindListeners() {
      this.closeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      });

      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) {
          this.close();
        }
      });

      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.code === 'Escape') {
          e.preventDefault();
          this.close();
        }
      });

      this.dialog.addEventListener('close', () => {
        this.onCloseComplete();
      });

      const imageLinks = this.dialog.querySelectorAll('.popup-image__link');
      imageLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          this.markAsClosed();
          this.close();
        });
      });
    }

    showPopupWithDelay() {
      const isSubmitted = window.location.href.indexOf('accepts_marketing') !== -1 || 
                         window.location.href.indexOf('customer_posted=true') !== -1;

      if (this.delay === 'always' || isSubmitted) {
        this.open();
        return;
      }

      if (this.delay && this.delay.includes('delayed')) {
        const seconds = this.delay.includes('_') 
          ? parseInt(this.delay.split('_')[1]) 
          : 10;
        
        setTimeout(() => {
          this.open();
        }, seconds * 1000);
        return;
      }

      if (this.delay === 'bottom') {
        this.showOnBottomReached();
        return;
      }

      if (this.delay === 'idle') {
        this.showOnIdle();
        return;
      }
    }

    open() {
      if (this.isAnimating || this.dialog.open) return;

      this.isAnimating = true;

      this.originalBodyOverflow = document.body.style.overflow;

      if (typeof this.dialog.showModal === 'function') {
        try {
          this.dialog.showModal();
        } catch (e) {
          this.dialog.setAttribute('open', '');
        }
      } else {
        this.dialog.setAttribute('open', '');
      }

      this.dialog.removeAttribute('inert');
      this.dialog.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
    }

    close() {
      if (this.isAnimating || !this.dialog.open) return;

      this.isAnimating = true;

      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.onCloseComplete();
      }
    }

    onCloseComplete() {
      this.dialog.setAttribute('inert', '');
      this.dialog.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = this.originalBodyOverflow;

      this.markAsClosed();

      this.isAnimating = false;
    }

    showOnBottomReached() {
      const checkScroll = () => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;
        
        if (scrollPosition >= pageHeight - 100) {
          this.open();
          window.removeEventListener('scroll', checkScroll);
        }
      };

      window.addEventListener('scroll', checkScroll);
      
      this._scrollCleanup = () => window.removeEventListener('scroll', checkScroll);
    }

    showOnIdle() {
      let timer = null;
      const idleTime = 60000; 
      const events = [
        'mousemove', 'mousedown', 'click', 'touchmove', 
        'touchstart', 'touchend', 'keydown', 'keypress',
        'scroll', 'resize'
      ];

      const resetTimer = () => {
        if (timer) {
          clearTimeout(timer);
        }

        timer = setTimeout(() => {
          this.open();
          cleanup();
        }, idleTime);
      };

      const cleanup = () => {
        if (timer) {
          clearTimeout(timer);
        }
        events.forEach(event => {
          document.removeEventListener(event, resetTimer);
        });
      };

      events.forEach(event => {
        document.addEventListener(event, resetTimer);
      });
      resetTimer();

      this._idleCleanup = cleanup;
    }

    disconnectedCallback() {
      if (this._scrollCleanup) {
        this._scrollCleanup();
      }
      if (this._idleCleanup) {
        this._idleCleanup();
      }
    }
  }

  if (!customElements.get(POPUP_IMAGE_NAMESPACE)) {
    customElements.define(POPUP_IMAGE_NAMESPACE, PopupImageComponent);
  }
})();